<template>
  <div class="grm-checkbox-container" :class="{ disabled }">
    <input
      type="checkbox"
      class="grm-checkbox"
      :id="id"
      :name="id"
      :checked="value"
      @input="$emit('input', $event.target.checked)"
    />
    <label
      class="grm-checkbox-label"
      :for="id"
    >
      <slot></slot>
    </label>
  </div>
</template>

<script>
export default {
  name: 'GrmCheckbox',
  props: {
    id: { required: true },
    value: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  }
}
</script>

<style lang="scss" scoped>
.grm-checkbox-container {
  display: flex;
  align-items: center;
  &.disabled {
    pointer-events: none;
    user-select: none;
    .grm-checkbox-label {
      color: $errorColor;
      &::before {
        border: 1px solid $errorColor;
      }
    }
  }
}
.grm-checkbox {
  display: none;
  &:checked {
    & + .grm-checkbox-label {
      color: $successColor;
      &::before {
        border: 1px solid $successColor;
        background: $successColor url('~@/assets/images/check_white.svg') no-repeat center / 10px auto;
      }
    }
  }
}
.grm-checkbox-label {
  font-size: 12px;
  color: #666;
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  transition: 0.2s ease-out;
  &::before {
    content: '';
    width: 16px;
    height: 16px;
    margin-right: 8px;
    border: 1px solid #666;
    border-radius: 100%;
    background: #fff url('~@/assets/images/check_white.svg') no-repeat center / 10px auto;
    display: inline-block;
    transition: 0.2s ease-out;
  }
}
</style>